import { FC, MouseEvent, useRef } from "react";
import styles from "./Drawer.module.scss";
import clsx from "clsx";
import { IDrawerState } from "@/app/providers/DrawerProvider/types";

interface DrawerProps {
  drawer: IDrawerState;
  onClose?: () => void;
}

export const Drawer: FC<DrawerProps> = ({ drawer, onClose }) => {
  const downTargetRef = useRef<EventTarget | null>(null);

  if (!drawer.node || !drawer.isOpen) {
    return null;
  }

  const { isOpen, node, options } = drawer;
  const {
    customWidthPercent,
    maxWidth,
    width: widthPx,
    isBig,
    noPaddings,
    hideScroll,
    showXScroll,
  } = options;

  const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
    downTargetRef.current = e.target;
  };

  const handleContainerClick = () => {
    if (downTargetRef.current) {
      const downTarget = downTargetRef.current as HTMLElement;
      if (
        downTarget.id === "right_plate" ||
        downTarget.closest("#right_plate")
      ) {
        downTargetRef.current = null;
        return;
      }
    }

    onClose?.();
    downTargetRef.current = null;
  };

  return (
    <>
      <div
        onMouseDown={handleMouseDown}
        onClick={handleContainerClick}
        className={clsx(styles.drawerContainer, {
          [styles.close]: !isOpen,
        })}
      >
        <div
          id="right_plate"
          style={{
            width: widthPx
              ? `${widthPx}px`
              : customWidthPercent
                ? String(customWidthPercent) + "%"
                : "",
            maxWidth:
              maxWidth != null
                ? `${maxWidth}px`
                : widthPx != null
                  ? `${widthPx}px`
                  : "",
          }}
          className={clsx(styles.drawerMain, {
            [styles.close]: !isOpen,
            [styles.isBig]: isBig,
            [styles.noPaddings]: noPaddings,
          })}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className={clsx(styles.plateContent, {
              [styles.hideScroll]: hideScroll,
              [styles.showXScroll]: showXScroll,
            })}
          >
            {node}
          </div>
        </div>
      </div>
    </>
  );
};
